/* istanbul ignore file */
/* eslint-disable max-lines,quotes */
/*
    The file is auto-generated by graphql-codegen.
    Please use `yarn update-schema`
*/

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTimeTimestamp: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  TimeDeltaTimestamp: any;
  Upload: any;
};

export type Account = {
  __typename?: 'Account';
  id: Scalars['ID'];
  code: Scalars['ID'];
  name: Scalars['String'];
  attemptsRemains: Scalars['Int'];
  studentsLimit: Scalars['Int'];
  membershipType?: Maybe<Scalars['String']>;
  receiveReports: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  allowRetries: Scalars['Boolean'];
  textLogo?: Maybe<Scalars['String']>;
  users?: Maybe<Array<User>>;
};

export type AccountBase = {
  __typename?: 'AccountBase';
  id: Scalars['ID'];
  code: Scalars['ID'];
  name: Scalars['String'];
};

export type Action = {
  id: Scalars['ID'];
};

export type ActionResult = {
  __typename?: 'ActionResult';
  actionId: Scalars['ID'];
  branchId?: Maybe<Scalars['ID']>;
  branchIds?: Maybe<Array<Scalars['ID']>>;
  duration: Scalars['TimeDeltaTimestamp'];
  attempts: Scalars['Int'];
  isSkipped: Scalars['Boolean'];
  usedHint: Scalars['Boolean'];
  passed: Scalars['Boolean'];
  audio?: Maybe<Scalars['String']>;
  recognizedText?: Maybe<Scalars['String']>;
  recognizedTextPairs?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']>>>>>;
  partlyPassed?: Maybe<Scalars['Boolean']>;
  pitchRangeRatio?: Maybe<Scalars['Float']>;
  pitchRange?: Maybe<PitchRange>;
  speechSpeedRatio?: Maybe<Scalars['Float']>;
  speechSpeed?: Maybe<SpeechSpeed>;
  emotionJoy?: Maybe<Scalars['Float']>;
  emotionNeutral?: Maybe<Scalars['Float']>;
  emotionEnthusiasm?: Maybe<Scalars['Float']>;
  emotionAnger?: Maybe<Scalars['Float']>;
  emotionSurprise?: Maybe<Scalars['Float']>;
  emotionSadness?: Maybe<Scalars['Float']>;
  emotionDisgust?: Maybe<Scalars['Float']>;
  emotionFear?: Maybe<Scalars['Float']>;
  emotionShame?: Maybe<Scalars['Float']>;
  emotionGuilt?: Maybe<Scalars['Float']>;
  freeSpeechMessage?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  detailedAttempts: DetailedAttempts;
  adaptiveInputUuid?: Maybe<Scalars['ID']>;
};

export type AdaptiveInput = {
  __typename?: 'AdaptiveInput';
  id: Scalars['ID'];
  uuid: Scalars['String'];
  isClosed: Scalars['Boolean'];
  isError: Scalars['Boolean'];
  responses: Array<AdaptiveResponse>;
};

export type AdaptiveResponse = {
  __typename?: 'AdaptiveResponse';
  id: Scalars['ID'];
  audioUrl?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  index: Scalars['Int'];
};

export type Admin = User & {
  __typename?: 'Admin';
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  extraEmail?: Maybe<Scalars['String']>;
  isStaff: Scalars['Boolean'];
  isDeveloper: Scalars['Boolean'];
  isExperimental: Scalars['Boolean'];
  experimentalMode: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  accountsCount: Scalars['Int'];
  groups: Array<Group>;
  top3Emotions: Array<EmotionStatType>;
  failReasons?: Maybe<Array<AssignmentFailReason>>;
  challenges?: Maybe<Array<ChallengeParticipationState>>;
};

export type AnonymousResult = {
  __typename?: 'AnonymousResult';
  uuid: Scalars['ID'];
  challenge: Challenge;
  project?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  finishedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  passed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  OS?: Maybe<Scalars['String']>;
  feedbackScore?: Maybe<Scalars['Int']>;
  feedbackText?: Maybe<Scalars['String']>;
  record?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['TimeDeltaTimestamp']>;
  recordState: EducationSessionRecordState;
  parametricResults: Array<ParametricResult>;
  actionResults: Array<ActionResult>;
  isContentMatches: Scalars['Boolean'];
  finishedScenariosIds: Array<Maybe<Scalars['ID']>>;
};

export type AnonymousSessionsPaginatedList = {
  __typename?: 'AnonymousSessionsPaginatedList';
  items: Array<AnonymousResult>;
  countItems?: Maybe<Scalars['Int']>;
};

export type AssignmentErrorsData = {
  __typename?: 'AssignmentErrorsData';
  challenges: Array<ChallengeParticipationState>;
  projects: Array<ProjectParticipationState>;
};

/** An enumeration. */
export enum AssignmentFailReason {
  ALREADY_ASSIGNED = 'ALREADY_ASSIGNED',
  INACTIVE_USER = 'INACTIVE_USER',
  PARTLY_ASSIGNED = 'PARTLY_ASSIGNED'
}

export type Avatar = {
  __typename?: 'Avatar';
  id: Scalars['ID'];
  gender: Gender;
  name: Scalars['String'];
  preview: Scalars['String'];
  previewFull: Scalars['String'];
  modelType: AvatarModelType;
  gltfAsset: Scalars['String'];
};


export type AvatarNameArgs = {
  languageCode?: Maybe<LanguageCode>;
};

export type AvatarAction = Action & {
  __typename?: 'AvatarAction';
  id: Scalars['ID'];
  audio?: Maybe<Scalars['String']>;
  isCustomAudio: Scalars['Boolean'];
  media?: Maybe<Scalars['String']>;
  mediaType?: Maybe<Scalars['String']>;
  mediaViewRequired?: Maybe<Scalars['Boolean']>;
  setMediaAsBackground?: Maybe<Scalars['Boolean']>;
  replaceCharacterWithMedia?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  emotion: AvatarEmotion;
  gesture: AvatarGesture;
};

export type AvatarActionInput = {
  text?: Maybe<Scalars['String']>;
  emotion?: Maybe<AvatarEmotion>;
  gesture?: Maybe<AvatarGesture>;
  customAudio?: Maybe<Scalars['Upload']>;
  regenerateAudio?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Scalars['Upload']>;
  mediaViewRequired?: Maybe<Scalars['Boolean']>;
  setMediaAsBackground?: Maybe<Scalars['Boolean']>;
  replaceCharacterWithMedia?: Maybe<Scalars['Boolean']>;
  beforeActionId?: Maybe<Scalars['ID']>;
};

/** An enumeration. */
export enum AvatarEmotion {
  IDLE = 'IDLE',
  SURPRISED = 'SURPRISED',
  ANGRY = 'ANGRY',
  DISAPPOINTED = 'DISAPPOINTED',
  SMILING = 'SMILING'
}

/** An enumeration. */
export enum AvatarGesture {
  IDLE = 'IDLE',
  POINT_RIGHT = 'POINT_RIGHT',
  AGREEMENT = 'AGREEMENT',
  NARRATIVE = 'NARRATIVE',
  RIGHTLY = 'RIGHTLY',
  NO = 'NO',
  THUMBS_UP = 'THUMBS_UP',
  CONFUSION = 'CONFUSION',
  STRONG_NO = 'STRONG_NO',
  SUFFERING = 'SUFFERING',
  ANNOYANCE = 'ANNOYANCE',
  APATHY = 'APATHY',
  ASSURANCE = 'ASSURANCE',
  DESPONDENCY = 'DESPONDENCY',
  DISCUSSION = 'DISCUSSION',
  GREETINGS = 'GREETINGS',
  REGRET = 'REGRET',
  TRUST = 'TRUST'
}

/** An enumeration. */
export enum AvatarModelType {
  UNKNOWN = 'UNKNOWN',
  ICLONE = 'ICLONE',
  WOLF3D = 'WOLF3D'
}

export type Challenge = {
  __typename?: 'Challenge';
  id: Scalars['ID'];
  name: Scalars['String'];
  accessToken: Scalars['String'];
  createdAt: Scalars['DateTimeTimestamp'];
  lastUpdatedAt: Scalars['DateTimeTimestamp'];
  accountId?: Maybe<Scalars['ID']>;
  projectName?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['ID']>;
  avatar: Avatar;
  gestures: Array<Scalars['String']>;
  languageCode: LanguageCode;
  isInitial?: Maybe<Scalars['Boolean']>;
  recognitionEngine: ChallengeRecognitionEngine;
  recognitionAccuracy: ChallengeRecognitionAccuracy;
  mode: ChallengeMode;
  displayMode: ChallengeDisplayMode;
  inputMode: ChallengeInputMode;
  badWordsFilter: ChallengeBadWordsFilter;
  generateVideo?: Maybe<Scalars['Boolean']>;
  inviteByLink?: Maybe<Scalars['Boolean']>;
  useCharacterVoiceForErrors?: Maybe<Scalars['Boolean']>;
  muteNonUserSpeech?: Maybe<Scalars['Boolean']>;
  showPreviousPhrase?: Maybe<Scalars['Boolean']>;
  showDetailedResults?: Maybe<Scalars['Boolean']>;
  evaluateScenarios?: Maybe<Scalars['Boolean']>;
  selectableInputs?: Maybe<Scalars['Boolean']>;
  alwaysCanSkipSteps?: Maybe<Scalars['Boolean']>;
  ignoreFailedInputs?: Maybe<Scalars['Boolean']>;
  showResultsForEachParameter?: Maybe<Scalars['Boolean']>;
  startMessage?: Maybe<Scalars['String']>;
  resultMessage?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  scormDownloadUrl: Scalars['String'];
  contentExportUrl?: Maybe<Scalars['String']>;
  activateAt?: Maybe<Scalars['DateTimeTimestamp']>;
  participationCreatedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  canPlay?: Maybe<Scalars['Boolean']>;
  deactivateReason?: Maybe<ParticipationDeactivateReason>;
  canResume?: Maybe<Scalars['Boolean']>;
  hasPassed?: Maybe<Scalars['Boolean']>;
  attemptsLimit?: Maybe<Scalars['Int']>;
  timeLimit?: Maybe<Scalars['Int']>;
  actionTimeLimit?: Maybe<Scalars['Int']>;
  inputPhraseMaxLength?: Maybe<Scalars['Int']>;
  avatarPhraseMaxLength?: Maybe<Scalars['Int']>;
  systemPhraseMaxLength?: Maybe<Scalars['Int']>;
  customParameters: Array<CustomParameter>;
  displayParametricResultMode: DisplayParametricResultMode;
  multipleChoiceScoringOption?: Maybe<MultipleChoiceScoringOption>;
  avatarVoiceId?: Maybe<Scalars['String']>;
  systemVoiceId?: Maybe<Scalars['String']>;
  competences?: Maybe<Array<Competence>>;
  isAllResponsesEnabled?: Maybe<Scalars['Boolean']>;
  isSessionResultFeedbackEnabled?: Maybe<Scalars['Boolean']>;
  instructionFile?: Maybe<Scalars['String']>;
  instructionFileName?: Maybe<Scalars['String']>;
  rpgInstructionParseStatus?: Maybe<RpgInstructionParseStatus>;
  isAgentStart?: Maybe<Scalars['Boolean']>;
  rpgInstructionTemplateDownloadUrl?: Maybe<Scalars['String']>;
};

export enum ChallengeBadWordsFilter {
  NO = 'NO',
  FAIL = 'FAIL',
  INTERRUPT = 'INTERRUPT'
}

export enum ChallengeDisplayMode {
  DEFAULT = 'DEFAULT',
  VIDEO_CALL = 'VIDEO_CALL'
}

export type ChallengeEducationState = {
  __typename?: 'ChallengeEducationState';
  status: ChallengeEducationStatus;
  bestAttempt?: Maybe<EducationSessionResult>;
  lastAttempt?: Maybe<EducationSessionResult>;
  canRetry: Scalars['Boolean'];
  attemptsCount?: Maybe<Scalars['Int']>;
  passedAttemptsCount?: Maybe<Scalars['Int']>;
  resultDescription?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  challengeId?: Maybe<Scalars['ID']>;
};

export enum ChallengeEducationStatus {
  NOT_STARTED = 'NOT_STARTED',
  ACTIVE = 'ACTIVE',
  COMPLETE = 'COMPLETE'
}

export type ChallengeFilterInput = {
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<LanguageCode>;
  challengeMode?: Maybe<ChallengeMode>;
  projectId?: Maybe<Scalars['ID']>;
  competenceIds?: Maybe<Array<Scalars['ID']>>;
};

export type ChallengeInput = {
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<LanguageCode>;
  recognitionEngine?: Maybe<ChallengeRecognitionEngine>;
  recognitionAccuracy?: Maybe<ChallengeRecognitionAccuracy>;
  avatarId?: Maybe<Scalars['ID']>;
  projectId?: Maybe<Scalars['ID']>;
  mode?: Maybe<ChallengeMode>;
  displayMode?: Maybe<ChallengeDisplayMode>;
  inputMode?: Maybe<ChallengeInputMode>;
  badWordsFilter?: Maybe<ChallengeBadWordsFilter>;
  generateVideo?: Maybe<Scalars['Boolean']>;
  background?: Maybe<Scalars['Upload']>;
  regenerateAudio?: Maybe<Scalars['Boolean']>;
  showDetailedResults?: Maybe<Scalars['Boolean']>;
  evaluateScenarios?: Maybe<Scalars['Boolean']>;
  selectableInputs?: Maybe<Scalars['Boolean']>;
  alwaysCanSkipSteps?: Maybe<Scalars['Boolean']>;
  ignoreFailedInputs?: Maybe<Scalars['Boolean']>;
  showResultsForEachParameter?: Maybe<Scalars['Boolean']>;
  inviteByLink?: Maybe<Scalars['Boolean']>;
  useCharacterVoiceForErrors?: Maybe<Scalars['Boolean']>;
  muteNonUserSpeech?: Maybe<Scalars['Boolean']>;
  showPreviousPhrase?: Maybe<Scalars['Boolean']>;
  startMessage?: Maybe<Scalars['String']>;
  resultMessage?: Maybe<Scalars['String']>;
  beforeChallengeId?: Maybe<Scalars['ID']>;
  attemptsLimit?: Maybe<Scalars['Int']>;
  timeLimit?: Maybe<Scalars['Int']>;
  actionTimeLimit?: Maybe<Scalars['Int']>;
  inputPhraseMaxLength?: Maybe<Scalars['Int']>;
  avatarPhraseMaxLength?: Maybe<Scalars['Int']>;
  systemPhraseMaxLength?: Maybe<Scalars['Int']>;
  customParameterIds?: Maybe<Array<Scalars['ID']>>;
  displayParametricResultMode?: Maybe<DisplayParametricResultMode>;
  multipleChoiceScoringOption?: Maybe<MultipleChoiceScoringOption>;
  avatarVoiceId?: Maybe<Scalars['String']>;
  systemVoiceId?: Maybe<Scalars['String']>;
  competenceIds?: Maybe<Array<Scalars['String']>>;
  isAllResponsesEnabled?: Maybe<Scalars['Boolean']>;
  isSessionResultFeedbackEnabled?: Maybe<Scalars['Boolean']>;
  instructionFile?: Maybe<Scalars['Upload']>;
  isAgentStart?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ChallengeInputMode {
  VOICE = 'VOICE',
  TEXT = 'TEXT'
}

/** An enumeration. */
export enum ChallengeMode {
  COMPETENCE_TEST = 'COMPETENCE_TEST',
  CHOICE_BASED_STUDY = 'CHOICE_BASED_STUDY',
  CHOICES_WITH_CUSTOM_SCORES = 'CHOICES_WITH_CUSTOM_SCORES',
  CUSTOM_PARAMETERS_TEST = 'CUSTOM_PARAMETERS_TEST',
  RPG_MODE = 'RPG_MODE'
}

export enum ChallengeOrderBy {
  ID = 'ID',
  NAME = 'NAME',
  CREATED_AT = 'CREATED_AT',
  LAST_UPDATED_AT = 'LAST_UPDATED_AT'
}

export type ChallengeParticipantsType = {
  challengeId: Scalars['ID'];
  activateAt?: Maybe<Scalars['DateTimeTimestamp']>;
  deactivateAt?: Maybe<Scalars['DateTimeTimestamp']>;
};

export type ChallengeParticipationState = {
  __typename?: 'ChallengeParticipationState';
  id: Scalars['ID'];
  name: Scalars['String'];
  alreadyAssigned?: Maybe<Scalars['Boolean']>;
  activateAt?: Maybe<Scalars['DateTimeTimestamp']>;
  deactivateAt?: Maybe<Scalars['DateTimeTimestamp']>;
  projectName?: Maybe<Scalars['String']>;
};

export type ChallengeParticipationSummary = {
  __typename?: 'ChallengeParticipationSummary';
  assignments: Scalars['Int'];
  started: Scalars['Int'];
  finished: Scalars['Int'];
  passed: Scalars['Int'];
};

export type ChallengeProject = Challenge | Project;

export enum ChallengeRecognitionAccuracy {
  WEAK = 'WEAK',
  NORMAL = 'NORMAL',
  STRONG = 'STRONG'
}

export enum ChallengeRecognitionEngine {
  IDENTIFY = 'IDENTIFY',
  DAILOSPEECH = 'DAILOSPEECH'
}

/** An enumeration. */
export enum ChallengeScenarioActivationMethod {
  TRIGGER_PHRASE = 'TRIGGER_PHRASE',
  USER_INPUT = 'USER_INPUT'
}

/** An enumeration. */
export enum ChallengeScenarioAfterAction {
  RETURN = 'RETURN',
  NEXT = 'NEXT',
  INTERRUPT = 'INTERRUPT',
  FINISH = 'FINISH',
  NEXT_SCENARIO = 'NEXT_SCENARIO'
}

/** An enumeration. */
export enum ChallengeScenarioAfterActionTarget {
  MAIN = 'MAIN',
  PREVIOUS = 'PREVIOUS',
  NEXT_SCENARIO = 'NEXT_SCENARIO'
}

export type ChoiceUserInputAction = Action & {
  __typename?: 'ChoiceUserInputAction';
  id: Scalars['ID'];
  branches: Array<ChoiceUserInputBranch>;
  isMultipleChoice?: Maybe<Scalars['Boolean']>;
  questionText: Scalars['String'];
  hintText: Scalars['String'];
  competence?: Maybe<Competence>;
};

export type ChoiceUserInputActionInput = {
  beforeActionId?: Maybe<Scalars['ID']>;
  branches?: Maybe<Array<ChoiceUserInputBranchInput>>;
  isMultipleChoice?: Maybe<Scalars['Boolean']>;
  questionText?: Maybe<Scalars['String']>;
  hintText?: Maybe<Scalars['String']>;
  competenceId?: Maybe<Scalars['String']>;
};

export type ChoiceUserInputBranch = {
  __typename?: 'ChoiceUserInputBranch';
  id: Scalars['ID'];
  userInput: UserInputAction;
  avatarReaction?: Maybe<AvatarAction>;
  systemReaction?: Maybe<SystemAction>;
  state: ChoiceUserInputBranchState;
  customScore?: Maybe<Scalars['Int']>;
  customParameter?: Maybe<CustomParameter>;
  targetScenarioId?: Maybe<Scalars['ID']>;
};

export type ChoiceUserInputBranchInput = {
  referenceText?: Maybe<Scalars['String']>;
  analogTexts?: Maybe<Array<Scalars['String']>>;
  hintText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  state?: Maybe<ChoiceUserInputBranchState>;
  customScore?: Maybe<Scalars['Int']>;
  customParameterId?: Maybe<Scalars['ID']>;
  targetScenarioId?: Maybe<Scalars['ID']>;
  hasAvatarReaction?: Maybe<Scalars['Boolean']>;
  hasSystemReaction?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ChoiceUserInputBranchState {
  CORRECT = 'CORRECT',
  INCORRECT = 'INCORRECT',
  INTERRUPT = 'INTERRUPT'
}

export type Competence = {
  __typename?: 'Competence';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  indicators?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum CompetenceAnalysisState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  READY = 'READY',
  ERROR = 'ERROR',
  UNKNOWN = 'UNKNOWN'
}

export type CompetenceIndicatorResult = {
  __typename?: 'CompetenceIndicatorResult';
  indicator: Scalars['String'];
  isPresent: Scalars['Boolean'];
  example?: Maybe<Scalars['String']>;
};

export type CompetenceResult = {
  __typename?: 'CompetenceResult';
  competence: Scalars['String'];
  score: Scalars['Float'];
  feedback?: Maybe<Scalars['String']>;
  indicators?: Maybe<Array<CompetenceIndicatorResult>>;
};

export type Contract = {
  __typename?: 'Contract';
  expireAt: Scalars['DateTimeTimestamp'];
  licensesCount: Scalars['Int'];
  licensesUsed: Scalars['Int'];
  isActive: Scalars['Boolean'];
};

export type CustomParameter = {
  __typename?: 'CustomParameter';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CutWordsDictionary = {
  __typename?: 'CutWordsDictionary';
  id: Scalars['ID'];
  name: Scalars['String'];
  cutWordPairs?: Maybe<Scalars['String']>;
};

export type CutWordsDictionaryInput = {
  name?: Maybe<Scalars['String']>;
  cutWordPairs?: Maybe<Scalars['String']>;
};


export type DetailedAttempts = {
  __typename?: 'DetailedAttempts';
  passed: Scalars['Int'];
  failed: Scalars['Int'];
};

export type DetailedSessionFeedback = {
  __typename?: 'DetailedSessionFeedback';
  recognition?: Maybe<Scalars['Boolean']>;
  performance?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['Boolean']>;
  format?: Maybe<Scalars['Boolean']>;
  difficulty?: Maybe<Scalars['Boolean']>;
  hardware?: Maybe<Scalars['Boolean']>;
};

export type DetailedSessionFeedbackInput = {
  recognition?: Maybe<Scalars['Boolean']>;
  performance?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['Boolean']>;
  format?: Maybe<Scalars['Boolean']>;
  difficulty?: Maybe<Scalars['Boolean']>;
  hardware?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum DisplayParametricResultMode {
  RAW_SUM = 'RAW_SUM',
  PERCENTAGE = 'PERCENTAGE',
  SCENARIO_AVG = 'SCENARIO_AVG'
}

export type Editor = User & {
  __typename?: 'Editor';
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  extraEmail?: Maybe<Scalars['String']>;
  isStaff: Scalars['Boolean'];
  isDeveloper: Scalars['Boolean'];
  isExperimental: Scalars['Boolean'];
  experimentalMode: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  accountsCount: Scalars['Int'];
  groups: Array<Group>;
  top3Emotions: Array<EmotionStatType>;
  failReasons?: Maybe<Array<AssignmentFailReason>>;
  challenges?: Maybe<Array<ChallengeParticipationState>>;
};

export type EducationMemberFilterInput = {
  email?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  challengeId?: Maybe<Scalars['ID']>;
  projectId?: Maybe<Scalars['ID']>;
  completed?: Maybe<Scalars['Boolean']>;
  groupsIds?: Maybe<Array<Scalars['ID']>>;
  daysAmount?: Maybe<Scalars['Int']>;
  adminFilter?: Maybe<Scalars['Boolean']>;
  emotion?: Maybe<UserEmotion>;
  participationState?: Maybe<ParticipationState>;
};

export type EducationMemberRow = {
  __typename?: 'EducationMemberRow';
  id: Scalars['ID'];
  efficiency?: Maybe<Scalars['Float']>;
  participations: Array<Participation>;
  user: User;
  averageScore?: Maybe<Scalars['Float']>;
  averageFeedbackScore?: Maybe<Scalars['Float']>;
  attemptsCount?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['DateTimeTimestamp']>;
};

/** An enumeration. */
export enum EducationMemberSortField {
  EFFICIENCY = 'EFFICIENCY',
  ACTIVE = 'ACTIVE',
  AVERAGE_SCORE = 'AVERAGE_SCORE',
  AVERAGE_FEEDBACK_SCORE = 'AVERAGE_FEEDBACK_SCORE',
  ATTEMPTS_COUNT = 'ATTEMPTS_COUNT',
  STARTED_AT = 'STARTED_AT',
  EMAIL = 'EMAIL'
}

export type EducationMemberSortInput = {
  field?: Maybe<EducationMemberSortField>;
  direction?: Maybe<SortDirection>;
};

export type EducationMembersPaginatedList = {
  __typename?: 'EducationMembersPaginatedList';
  items: Array<EducationMemberRow>;
  countItems: Scalars['Int'];
};

export type EducationMembersSummary = {
  __typename?: 'EducationMembersSummary';
  total: Scalars['Int'];
  active: Scalars['Int'];
};

export enum EducationSessionErrorReason {
  NO_ANSWER = 'NO_ANSWER',
  WRONG_ANSWER = 'WRONG_ANSWER',
  BAD_WORD = 'BAD_WORD',
  TIME_EXPIRED = 'TIME_EXPIRED',
  WRONG_CHOICE = 'WRONG_CHOICE',
  MISSING_KEYWORD = 'MISSING_KEYWORD',
  DAILO_SPEECH_TIMEOUT = 'DAILO_SPEECH_TIMEOUT',
  DAILO_SPEECH_HTTP_ERROR = 'DAILO_SPEECH_HTTP_ERROR',
  STOP_WORDS = 'STOP_WORDS',
  DAILO_STT_ERROR = 'DAILO_STT_ERROR',
  CHALLENGE_TIME_LIMIT_EXPIRED = 'CHALLENGE_TIME_LIMIT_EXPIRED',
  VIEWA_SERVICE_ERROR = 'VIEWA_SERVICE_ERROR'
}

export type EducationSessionPassedResult = {
  __typename?: 'EducationSessionPassedResult';
  branchId?: Maybe<Scalars['ID']>;
  scenarioId?: Maybe<Scalars['ID']>;
  passed?: Maybe<Scalars['Boolean']>;
  interrupt: Scalars['Boolean'];
  recognizedText?: Maybe<Scalars['String']>;
  errorReason?: Maybe<EducationSessionErrorReason>;
  inputId?: Maybe<Scalars['ID']>;
  waitForFeedback?: Maybe<Scalars['Boolean']>;
};

export type EducationSessionProgress = {
  __typename?: 'EducationSessionProgress';
  sessionId: Scalars['ID'];
  level: Scalars['Int'];
  openedActions: Array<Scalars['ID']>;
  exposedActions: Array<Scalars['ID']>;
  lastMainScenarioAction?: Maybe<Scalars['ID']>;
  lastScenarioAction?: Maybe<Scalars['ID']>;
  lastScenarioId?: Maybe<Scalars['ID']>;
  lastPrevScenarioActionIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  prevScenarioIds?: Maybe<Array<Scalars['ID']>>;
};

export enum EducationSessionRecordState {
  NOT_STARTED = 'NOT_STARTED',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED'
}

export type EducationSessionResult = {
  __typename?: 'EducationSessionResult';
  sessionId: Scalars['ID'];
  passed: Scalars['Boolean'];
  score: Scalars['Int'];
  time: Scalars['TimeDeltaTimestamp'];
  usedHints: Scalars['Int'];
  requestFeedback: Scalars['Boolean'];
  record?: Maybe<Scalars['String']>;
  recordState: EducationSessionRecordState;
  actionResults: Array<ActionResult>;
  isContentMatches: Scalars['Boolean'];
  parametricResults: Array<ParametricResult>;
  finishedScenariosIds: Array<Maybe<Scalars['ID']>>;
  startedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  feedbackScore?: Maybe<Scalars['Int']>;
  feedbackText?: Maybe<Scalars['String']>;
  feedbackContacts?: Maybe<Scalars['String']>;
  detailedFeedback: DetailedSessionFeedback;
  generalSentimentNeutral?: Maybe<Scalars['Int']>;
  generalSentimentPositive?: Maybe<Scalars['Int']>;
  generalSentimentNegative?: Maybe<Scalars['Int']>;
  generalEmotionNeutral?: Maybe<Scalars['Int']>;
  generalEmotionJoy?: Maybe<Scalars['Int']>;
  generalEmotionEnthusiasm?: Maybe<Scalars['Int']>;
  generalEmotionAnger?: Maybe<Scalars['Int']>;
  generalEmotionGuilt?: Maybe<Scalars['Int']>;
  generalEmotionShame?: Maybe<Scalars['Int']>;
  generalEmotionFear?: Maybe<Scalars['Int']>;
  generalEmotionDisgust?: Maybe<Scalars['Int']>;
  generalEmotionSadness?: Maybe<Scalars['Int']>;
  generalEmotionSurprise?: Maybe<Scalars['Int']>;
  competenceResults?: Maybe<Array<CompetenceResult>>;
  competenceAnalysisState: CompetenceAnalysisState;
  isUserInputAnalysisReady?: Maybe<Scalars['Boolean']>;
  resultFeedback?: Maybe<SessionResultFeedback>;
  initAvatarAction?: Maybe<InitAvatarAction>;
};

export type EmotionStatType = {
  __typename?: 'EmotionStatType';
  key: UserEmotion;
  value: Scalars['Float'];
};

export type ErrorAudio = {
  __typename?: 'ErrorAudio';
  errorReason: UserInputErrorReason;
  filepath: Scalars['String'];
  gesture: AvatarGesture;
  emotion: AvatarEmotion;
  variantsCount: Scalars['Int'];
};

export type ExternalUser = {
  __typename?: 'ExternalUser';
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
};

export enum FeedbackStatusEnumType {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  READY = 'READY',
  ERROR = 'ERROR',
  DISABLED = 'DISABLED'
}

export type FpsInput = {
  timestamp: Scalars['String'];
  fps: Scalars['Int'];
  deltaTime: Scalars['Int'];
};

/** An enumeration. */
export enum Gender {
  NOT_SET = 'NOT_SET',
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

export type Group = {
  __typename?: 'Group';
  id: Scalars['ID'];
  name: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  users: Array<User>;
};

export type GroupInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  usersIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type HotWordsDictionary = {
  __typename?: 'HotWordsDictionary';
  id: Scalars['ID'];
  name: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};

export type HotWordsDictionaryInput = {
  name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type InitAvatarAction = {
  __typename?: 'InitAvatarAction';
  text: Scalars['String'];
  audio?: Maybe<Scalars['String']>;
};


/** An enumeration. */
export enum LanguageCode {
  EN_US = 'EN_US',
  RU_RU = 'RU_RU',
  SR_SP = 'SR_SP'
}

export type LoginSession = {
  __typename?: 'LoginSession';
  sessionId: Scalars['String'];
  user: User;
  account?: Maybe<Account>;
};

export type Manager = User & {
  __typename?: 'Manager';
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  extraEmail?: Maybe<Scalars['String']>;
  isStaff: Scalars['Boolean'];
  isDeveloper: Scalars['Boolean'];
  isExperimental: Scalars['Boolean'];
  experimentalMode: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  accountsCount: Scalars['Int'];
  groups: Array<Group>;
  top3Emotions: Array<EmotionStatType>;
  failReasons?: Maybe<Array<AssignmentFailReason>>;
  challenges?: Maybe<Array<ChallengeParticipationState>>;
};

export type MembershipInput = {
  isActive: Scalars['Boolean'];
};

/** An enumeration. */
export enum MultipleChoiceScoringOption {
  COMPLETELY_CORRECT = 'COMPLETELY_CORRECT',
  PARTLY_WITH_ERRORS = 'PARTLY_WITH_ERRORS'
}

export type Mutation = {
  __typename?: 'Mutation';
  sendFeedback: Scalars['Boolean'];
  sendFpsMeasures: Scalars['Boolean'];
  educationSessionStart: SessionStartResult;
  educationSessionResume?: Maybe<EducationSessionProgress>;
  educationSessionFinish?: Maybe<EducationSessionResult>;
  educationSessionStartLevel?: Maybe<Scalars['Boolean']>;
  educationSessionUseHint?: Maybe<Scalars['Boolean']>;
  educationSessionSkip?: Maybe<Scalars['Boolean']>;
  educationSessionPassStream?: Maybe<EducationSessionPassedResult>;
  educationSessionSubmitFeedback?: Maybe<Scalars['Boolean']>;
  educationSessionFinishScenario?: Maybe<Scalars['Boolean']>;
  educationSessionSelectInput?: Maybe<EducationSessionPassedResult>;
  educationSessionCheckSelectOrVoiceInput?: Maybe<EducationSessionPassedResult>;
  educationSessionMultipleSelectInput?: Maybe<EducationSessionPassedResult>;
  addParticipants?: Maybe<Array<Participation>>;
  addChallengeParticipants?: Maybe<Array<Participation>>;
  updateParticipation?: Maybe<Array<Participation>>;
  archiveParticipation?: Maybe<Array<Participation>>;
  tryInviteUserToChallenge?: Maybe<Scalars['ID']>;
  recalculateSessionScore?: Maybe<Scalars['Boolean']>;
  reanalyseSessionCompetenceResults?: Maybe<Scalars['Boolean']>;
  educationStartRpgPractice?: Maybe<StartRpgPracticeResult>;
  educationSessionPassAdaptiveInput?: Maybe<Scalars['Boolean']>;
  addChallenge?: Maybe<Challenge>;
  updateChallenge?: Maybe<Challenge>;
  deleteChallenge: Scalars['Boolean'];
  addProject?: Maybe<Project>;
  updateProject?: Maybe<Project>;
  deleteProject: Scalars['Boolean'];
  addAvatarAction: AvatarAction;
  updateAvatarAction: AvatarAction;
  addUserInputAction: UserInputAction;
  updateUserInputAction: UserInputAction;
  addSystemAction: SystemAction;
  updateSystemAction: SystemAction;
  addChoiceUserInputAction: ChoiceUserInputAction;
  updateChoiceUserInputAction: ChoiceUserInputAction;
  deleteAction: Scalars['Boolean'];
  copyAction: Scalars['Boolean'];
  addCompetence?: Maybe<Competence>;
  updateCompetence?: Maybe<Competence>;
  addScenario?: Maybe<Scenario>;
  updateScenario?: Maybe<Scenario>;
  deleteScenario: Scalars['Boolean'];
  addTriggerDictionary?: Maybe<TriggerDictionaryType>;
  updateTriggerDictionary?: Maybe<TriggerDictionaryType>;
  deleteTriggerDictionary: Scalars['Boolean'];
  addCutWordsDictionary?: Maybe<CutWordsDictionary>;
  updateCutWordsDictionary?: Maybe<CutWordsDictionary>;
  deleteCutWordsDictionary: Scalars['Boolean'];
  addHotWordsDictionary?: Maybe<HotWordsDictionary>;
  updateHotWordsDictionary?: Maybe<HotWordsDictionary>;
  deleteHotWordsDictionary: Scalars['Boolean'];
  addResultDescription?: Maybe<ResultDescription>;
  updateResultDescription?: Maybe<ResultDescription>;
  deleteResultDescription: Scalars['Boolean'];
  addParametricResultDescription?: Maybe<ParametricResultDescription>;
  updateParametricResultDescription?: Maybe<ParametricResultDescription>;
  deleteParametricResultDescription: Scalars['Boolean'];
  copyChallenge?: Maybe<Challenge>;
  copyProject?: Maybe<Project>;
  updateChildren?: Maybe<Scalars['Boolean']>;
  importChallengeCsv?: Maybe<Challenge>;
  addOfflineTestSession: OfflineTestSession;
  updateCustomParameter?: Maybe<CustomParameter>;
  addCustomParameter?: Maybe<CustomParameter>;
  deleteCustomParameter: Scalars['Boolean'];
  login?: Maybe<LoginSession>;
  loginWithProvider?: Maybe<LoginSession>;
  loginSelectAccount?: Maybe<LoginSession>;
  signUp?: Maybe<SignUpStatus>;
  resetPassword: Scalars['Boolean'];
  resetPasswordSetPassword?: Maybe<LoginSession>;
  requestExtraAttempts: Scalars['Boolean'];
  updateMembership: User;
  setExperimentalMode: User;
  addUsers: Array<User>;
  setReportsReceive: Scalars['Boolean'];
  setUsersActivity: Array<User>;
  setExtraEmail: Scalars['Boolean'];
  importMembersCsv: Scalars['String'];
  addGroup?: Maybe<Group>;
  deleteGroup: Scalars['Boolean'];
  deactivateGroupMembers?: Maybe<Group>;
  updateGroup?: Maybe<Group>;
};


export type MutationSendFeedbackArgs = {
  actionId?: Maybe<Scalars['ID']>;
  attachment?: Maybe<Scalars['Upload']>;
  contact?: Maybe<Scalars['String']>;
  errorReason?: Maybe<Scalars['String']>;
  externalUserId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  sessionId?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};


export type MutationSendFpsMeasuresArgs = {
  measures: Array<FpsInput>;
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionStartArgs = {
  challengeId: Scalars['ID'];
  externalUserId?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  utm?: Maybe<Utm>;
};


export type MutationEducationSessionResumeArgs = {
  challengeId: Scalars['ID'];
  externalUserId?: Maybe<Scalars['ID']>;
};


export type MutationEducationSessionFinishArgs = {
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionStartLevelArgs = {
  level: Scalars['Int'];
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionUseHintArgs = {
  actionId: Scalars['ID'];
  level: Scalars['Int'];
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionSkipArgs = {
  actionId: Scalars['ID'];
  level: Scalars['Int'];
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionPassStreamArgs = {
  actionId: Scalars['ID'];
  audioUploadId?: Maybe<Scalars['ID']>;
  duration?: Maybe<Scalars['Float']>;
  level: Scalars['Int'];
  recognizedText?: Maybe<Scalars['String']>;
  sessionId: Scalars['ID'];
  sttError?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['ID'];
  videoUploadId?: Maybe<Scalars['ID']>;
};


export type MutationEducationSessionSubmitFeedbackArgs = {
  contacts?: Maybe<Scalars['String']>;
  data?: Maybe<DetailedSessionFeedbackInput>;
  message?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionFinishScenarioArgs = {
  actionId?: Maybe<Scalars['ID']>;
  level: Scalars['Int'];
  scenarioIds: Array<Scalars['ID']>;
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionSelectInputArgs = {
  actionId: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  level: Scalars['Int'];
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionCheckSelectOrVoiceInputArgs = {
  actionId: Scalars['ID'];
  audioUploadId?: Maybe<Scalars['ID']>;
  duration?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Int']>;
  level: Scalars['Int'];
  recognizedText?: Maybe<Scalars['String']>;
  sessionId: Scalars['ID'];
  sttError?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['ID']>;
  videoUploadId?: Maybe<Scalars['ID']>;
};


export type MutationEducationSessionMultipleSelectInputArgs = {
  actionId: Scalars['ID'];
  chosenBranches: Array<Scalars['ID']>;
  chosenBranchesData: Array<Maybe<Array<Maybe<Scalars['String']>>>>;
  level: Scalars['Int'];
  sessionId: Scalars['ID'];
};


export type MutationAddParticipantsArgs = {
  adminText?: Maybe<Scalars['String']>;
  challenges?: Maybe<Array<ChallengeParticipantsType>>;
  emails?: Maybe<Array<Scalars['String']>>;
  usersIds?: Maybe<Array<Scalars['ID']>>;
};


export type MutationAddChallengeParticipantsArgs = {
  challengeId: Scalars['ID'];
  participants: Array<ParticipantInput>;
};


export type MutationUpdateParticipationArgs = {
  challengeId?: Maybe<Scalars['ID']>;
  deactivateAt?: Maybe<Scalars['DateTimeTimestamp']>;
  emails?: Maybe<Array<Scalars['String']>>;
  projectId?: Maybe<Scalars['ID']>;
  status: Scalars['Boolean'];
  userId?: Maybe<Scalars['ID']>;
};


export type MutationArchiveParticipationArgs = {
  challengeId?: Maybe<Scalars['ID']>;
  emails?: Maybe<Array<Scalars['String']>>;
  projectId?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
};


export type MutationTryInviteUserToChallengeArgs = {
  accessKey: Scalars['String'];
  challengeId: Scalars['ID'];
};


export type MutationRecalculateSessionScoreArgs = {
  sessionId: Scalars['ID'];
};


export type MutationReanalyseSessionCompetenceResultsArgs = {
  sessionId: Scalars['ID'];
};


export type MutationEducationStartRpgPracticeArgs = {
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionPassAdaptiveInputArgs = {
  actionId: Scalars['ID'];
  adaptiveInputUuid: Scalars['String'];
  audioUuid?: Maybe<Scalars['String']>;
  recognizedText?: Maybe<Scalars['String']>;
  sessionId: Scalars['ID'];
};


export type MutationAddChallengeArgs = {
  data: ChallengeInput;
};


export type MutationUpdateChallengeArgs = {
  data: ChallengeInput;
  id: Scalars['ID'];
};


export type MutationDeleteChallengeArgs = {
  id: Scalars['ID'];
};


export type MutationAddProjectArgs = {
  data: ProjectInput;
};


export type MutationUpdateProjectArgs = {
  data: ProjectInput;
  id: Scalars['ID'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID'];
};


export type MutationAddAvatarActionArgs = {
  challengeId: Scalars['ID'];
  data: AvatarActionInput;
  scenarioId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateAvatarActionArgs = {
  actionId: Scalars['ID'];
  challengeId: Scalars['ID'];
  data: AvatarActionInput;
};


export type MutationAddUserInputActionArgs = {
  challengeId: Scalars['ID'];
  data: UserInputActionInput;
  scenarioId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateUserInputActionArgs = {
  actionId: Scalars['ID'];
  challengeId: Scalars['ID'];
  data: UserInputActionInput;
};


export type MutationAddSystemActionArgs = {
  challengeId: Scalars['ID'];
  data: SystemActionInput;
  scenarioId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateSystemActionArgs = {
  actionId: Scalars['ID'];
  challengeId: Scalars['ID'];
  data: SystemActionInput;
};


export type MutationAddChoiceUserInputActionArgs = {
  challengeId: Scalars['ID'];
  data: ChoiceUserInputActionInput;
  scenarioId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateChoiceUserInputActionArgs = {
  actionId: Scalars['ID'];
  challengeId: Scalars['ID'];
  data: ChoiceUserInputActionInput;
};


export type MutationDeleteActionArgs = {
  actionId: Scalars['ID'];
  challengeId: Scalars['ID'];
  path: Scalars['String'];
};


export type MutationCopyActionArgs = {
  actionId: Scalars['ID'];
  challengeId: Scalars['ID'];
  path: Scalars['String'];
};


export type MutationAddCompetenceArgs = {
  description?: Maybe<Scalars['String']>;
  indicators?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
};


export type MutationUpdateCompetenceArgs = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  indicators?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
};


export type MutationAddScenarioArgs = {
  challengeId: Scalars['ID'];
  data: ScenarioInput;
  path: Scalars['String'];
};


export type MutationUpdateScenarioArgs = {
  challengeId: Scalars['ID'];
  data: ScenarioInput;
  path: Scalars['String'];
  scenarioId: Scalars['ID'];
};


export type MutationDeleteScenarioArgs = {
  challengeId: Scalars['ID'];
  path: Scalars['String'];
  scenarioId: Scalars['ID'];
};


export type MutationAddTriggerDictionaryArgs = {
  challengeId: Scalars['ID'];
  data: TriggerDictionaryInput;
};


export type MutationUpdateTriggerDictionaryArgs = {
  challengeId: Scalars['ID'];
  data: TriggerDictionaryInput;
  triggerDictionaryId: Scalars['ID'];
};


export type MutationDeleteTriggerDictionaryArgs = {
  challengeId: Scalars['ID'];
  triggerDictionaryId: Scalars['ID'];
};


export type MutationAddCutWordsDictionaryArgs = {
  challengeId: Scalars['ID'];
  data: CutWordsDictionaryInput;
};


export type MutationUpdateCutWordsDictionaryArgs = {
  challengeId: Scalars['ID'];
  cutWordsDictionaryId: Scalars['ID'];
  data: CutWordsDictionaryInput;
};


export type MutationDeleteCutWordsDictionaryArgs = {
  challengeId: Scalars['ID'];
  cutWordsDictionaryId: Scalars['ID'];
};


export type MutationAddHotWordsDictionaryArgs = {
  challengeId: Scalars['ID'];
  data: HotWordsDictionaryInput;
};


export type MutationUpdateHotWordsDictionaryArgs = {
  challengeId: Scalars['ID'];
  data: HotWordsDictionaryInput;
  hotWordsDictionaryId: Scalars['ID'];
};


export type MutationDeleteHotWordsDictionaryArgs = {
  challengeId: Scalars['ID'];
  hotWordsDictionaryId: Scalars['ID'];
};


export type MutationAddResultDescriptionArgs = {
  challengeId: Scalars['ID'];
  data: ResultDescriptionInput;
};


export type MutationUpdateResultDescriptionArgs = {
  challengeId: Scalars['ID'];
  data: ResultDescriptionInput;
  resultDescriptionId: Scalars['ID'];
};


export type MutationDeleteResultDescriptionArgs = {
  challengeId: Scalars['ID'];
  resultDescriptionId: Scalars['ID'];
};


export type MutationAddParametricResultDescriptionArgs = {
  challengeId: Scalars['ID'];
  data: ParametricResultDescriptionInput;
};


export type MutationUpdateParametricResultDescriptionArgs = {
  challengeId: Scalars['ID'];
  data: ParametricResultDescriptionInput;
  resultDescriptionId: Scalars['ID'];
};


export type MutationDeleteParametricResultDescriptionArgs = {
  challengeId: Scalars['ID'];
  resultDescriptionId: Scalars['ID'];
};


export type MutationCopyChallengeArgs = {
  id: Scalars['ID'];
};


export type MutationCopyProjectArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateChildrenArgs = {
  challengeId?: Maybe<Scalars['ID']>;
  projectId?: Maybe<Scalars['ID']>;
};


export type MutationImportChallengeCsvArgs = {
  attachment: Scalars['Upload'];
  languageCode: LanguageCode;
};


export type MutationAddOfflineTestSessionArgs = {
  data: OfflineTestSessionInput;
};


export type MutationUpdateCustomParameterArgs = {
  name?: Maybe<Scalars['String']>;
  parameterId: Scalars['ID'];
};


export type MutationAddCustomParameterArgs = {
  name: Scalars['String'];
};


export type MutationDeleteCustomParameterArgs = {
  parameterId: Scalars['ID'];
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLoginWithProviderArgs = {
  provider: Scalars['String'];
  token: Scalars['String'];
};


export type MutationLoginSelectAccountArgs = {
  accountId?: Maybe<Scalars['ID']>;
};


export type MutationSignUpArgs = {
  accountId?: Maybe<Scalars['ID']>;
  fullname: Scalars['String'];
  languageCode: LanguageCode;
  password: Scalars['String'];
  repeatPassword: Scalars['String'];
  username: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
  languageCode?: Maybe<LanguageCode>;
};


export type MutationResetPasswordSetPasswordArgs = {
  hash: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationRequestExtraAttemptsArgs = {
  comment?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};


export type MutationUpdateMembershipArgs = {
  data: MembershipInput;
  userId: Scalars['ID'];
};


export type MutationSetExperimentalModeArgs = {
  experimentalMode: Scalars['Boolean'];
};


export type MutationAddUsersArgs = {
  emails: Array<Scalars['String']>;
  languageCode?: Maybe<LanguageCode>;
  names: Array<Scalars['String']>;
};


export type MutationSetReportsReceiveArgs = {
  status: Scalars['Boolean'];
};


export type MutationSetUsersActivityArgs = {
  emails: Array<Scalars['String']>;
  isActive: Scalars['Boolean'];
};


export type MutationSetExtraEmailArgs = {
  email: Scalars['String'];
};


export type MutationImportMembersCsvArgs = {
  attachment: Scalars['Upload'];
  emailLanguage: LanguageCode;
  overrideActive: Scalars['Boolean'];
  sendWelcomeEmails: Scalars['Boolean'];
};


export type MutationAddGroupArgs = {
  data: GroupInput;
};


export type MutationDeleteGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeactivateGroupMembersArgs = {
  groupId: Scalars['ID'];
};


export type MutationUpdateGroupArgs = {
  data: GroupInput;
  id: Scalars['ID'];
};

export type OfflineTestSession = {
  __typename?: 'OfflineTestSession';
  id: Scalars['ID'];
  uuid: Scalars['String'];
  name: Scalars['String'];
  user?: Maybe<User>;
  challenge: Challenge;
  audio?: Maybe<Scalars['String']>;
  results?: Maybe<Scalars['JSONString']>;
  competenceResults?: Maybe<Array<CompetenceResult>>;
  competenceAnalysisState: CompetenceAnalysisState;
  analyzedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  createdAt: Scalars['DateTimeTimestamp'];
  lastUpdatedAt: Scalars['DateTimeTimestamp'];
};

export type OfflineTestSessionInput = {
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  challengeId: Scalars['ID'];
  audio: Scalars['Upload'];
};

export type ParametricResult = {
  __typename?: 'ParametricResult';
  parameterId?: Maybe<Scalars['ID']>;
  parameterName?: Maybe<Scalars['String']>;
  rawSum: Scalars['Float'];
  percentage: Scalars['Float'];
};

export type ParametricResultCondition = {
  __typename?: 'ParametricResultCondition';
  parameter?: Maybe<CustomParameter>;
  competence?: Maybe<Competence>;
  minValue?: Maybe<Scalars['Int']>;
  maxValue?: Maybe<Scalars['Int']>;
};

export type ParametricResultConditionInput = {
  parameterId?: Maybe<Scalars['ID']>;
  competenceId?: Maybe<Scalars['ID']>;
  minValue?: Maybe<Scalars['Int']>;
  maxValue?: Maybe<Scalars['Int']>;
};

export type ParametricResultDescription = {
  __typename?: 'ParametricResultDescription';
  id: Scalars['ID'];
  conditions: Array<ParametricResultCondition>;
  message?: Maybe<Scalars['String']>;
};

export type ParametricResultDescriptionInput = {
  conditions?: Maybe<Array<ParametricResultConditionInput>>;
  message?: Maybe<Scalars['String']>;
};

export type ParticipantInput = {
  name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};

export type Participation = {
  __typename?: 'Participation';
  id: Scalars['ID'];
  student: Student;
  challenge: Challenge;
  attemptsCount: Scalars['Int'];
  attemptsTotalTime: Scalars['TimeDeltaTimestamp'];
  firstAttempt?: Maybe<EducationSessionResult>;
  bestAttempt?: Maybe<EducationSessionResult>;
  lastAttempt?: Maybe<EducationSessionResult>;
  activateAt?: Maybe<Scalars['DateTimeTimestamp']>;
  deactivateAt?: Maybe<Scalars['DateTimeTimestamp']>;
  deactivatedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  isActive: Scalars['Boolean'];
  /** @deprecated Moved to session */
  feedbackScore?: Maybe<Scalars['Int']>;
  /** @deprecated Moved to session */
  feedbackText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTimeTimestamp'];
  startedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  invited: Scalars['Boolean'];
  invitedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  /** @deprecated use invited */
  inviteSent: Scalars['Boolean'];
  /** @deprecated use invitedAt */
  inviteSentAt?: Maybe<Scalars['DateTimeTimestamp']>;
};

/** An enumeration. */
export enum ParticipationDeactivateReason {
  MANUAL = 'MANUAL',
  BY_ATTEMPTS = 'BY_ATTEMPTS',
  BY_DEACTIVATE_AT = 'BY_DEACTIVATE_AT',
  BY_ACTIVATE_AT = 'BY_ACTIVATE_AT'
}

/** An enumeration. */
export enum ParticipationState {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELAYED = 'DELAYED'
}

export enum PitchRange {
  MONOTONIC = 'MONOTONIC',
  REASONABLE = 'REASONABLE',
  EXPRESSIVE = 'EXPRESSIVE'
}

export type Project = {
  __typename?: 'Project';
  id: Scalars['ID'];
  name: Scalars['String'];
  accessToken: Scalars['String'];
  languageCode: LanguageCode;
  isInitial?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTimeTimestamp'];
  lastUpdatedAt: Scalars['DateTimeTimestamp'];
  challenges: Array<Challenge>;
  canPlay?: Maybe<Scalars['Boolean']>;
  hasPassed?: Maybe<Scalars['Boolean']>;
  participationCreatedAt?: Maybe<Scalars['DateTimeTimestamp']>;
};

export type ProjectInput = {
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<LanguageCode>;
};

export type ProjectParticipationState = {
  __typename?: 'ProjectParticipationState';
  id: Scalars['ID'];
  name: Scalars['String'];
  alreadyAssigned?: Maybe<Scalars['Boolean']>;
  challenges: Array<ChallengeParticipationState>;
};

export type Query = {
  __typename?: 'Query';
  getChallengeResults?: Maybe<Array<EducationSessionResult>>;
  getAssignedChallenges?: Maybe<Array<ChallengeProject>>;
  getSessionResult?: Maybe<EducationSessionResult>;
  getChallengeEducationState?: Maybe<ChallengeEducationState>;
  getChallengesEducationState?: Maybe<Array<ChallengeEducationState>>;
  getAccountMembers: EducationMembersPaginatedList;
  getAccountMembersSummary: EducationMembersSummary;
  getParticipationsSummary: ChallengeParticipationSummary;
  getAnonymousSessions: AnonymousSessionsPaginatedList;
  getAdaptiveInput: AdaptiveInput;
  getAccountUsersExportUrl: Scalars['String'];
  getAccountSessionsExportUrl: Scalars['String'];
  getChallengeTranscriptsExportUrl: Scalars['String'];
  getUserBestAttemptsExportUrlTemplate: Scalars['String'];
  getParticipationBestAttemptExportUrlTemplate: Scalars['String'];
  getChallenges: Array<ChallengeProject>;
  getProject?: Maybe<Project>;
  getProjects: Array<Project>;
  getChallenge?: Maybe<Challenge>;
  getChallengeActions?: Maybe<Array<Action>>;
  getChallengeScenarios?: Maybe<Array<Scenario>>;
  getChallengeTriggerDictionaries?: Maybe<Array<TriggerDictionaryType>>;
  getChallengeCutWordsDictionaries?: Maybe<Array<CutWordsDictionary>>;
  getChallengeHotWordsDictionaries?: Maybe<Array<HotWordsDictionary>>;
  getChallengeResultDescriptions?: Maybe<Array<ResultDescription>>;
  getChallengeParametricResultDescriptions?: Maybe<Array<ParametricResultDescription>>;
  getNextChallenge?: Maybe<Challenge>;
  getSupportedVoices?: Maybe<Array<Scalars['String']>>;
  getCompetencies?: Maybe<Array<Competence>>;
  getCompetenceTestTemplateUrl: Scalars['String'];
  getOfflineTestSessions?: Maybe<Array<OfflineTestSession>>;
  getAccountCustomParameters: Array<CustomParameter>;
  getAvatars: Array<Avatar>;
  getErrorsAudio?: Maybe<Array<ErrorAudio>>;
  getAvailableAccounts: Array<Account>;
  getCurrentAccount?: Maybe<Account>;
  getCurrentUser?: Maybe<User>;
  getUser?: Maybe<User>;
  getResetPasswordUser?: Maybe<ResetPasswordInformation>;
  getAccountByChallenge?: Maybe<AccountBase>;
  getExternalUser?: Maybe<ExternalUser>;
  getAccountContracts?: Maybe<Array<Contract>>;
  getGroups?: Maybe<Array<Group>>;
  getUsersByMixedData?: Maybe<UsersByMixedDataType>;
  getAssignmentErrorsData?: Maybe<AssignmentErrorsData>;
  getCurrentAccountUsers?: Maybe<Array<User>>;
};


export type QueryGetChallengeResultsArgs = {
  challengeId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};


export type QueryGetSessionResultArgs = {
  externalUserId?: Maybe<Scalars['ID']>;
  sessionId: Scalars['ID'];
};


export type QueryGetChallengeEducationStateArgs = {
  challengeId: Scalars['ID'];
  externalUserId?: Maybe<Scalars['ID']>;
};


export type QueryGetChallengesEducationStateArgs = {
  projectId?: Maybe<Scalars['ID']>;
};


export type QueryGetAccountMembersArgs = {
  filter?: Maybe<EducationMemberFilterInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  sort?: Maybe<EducationMemberSortInput>;
};


export type QueryGetParticipationsSummaryArgs = {
  challengeId?: Maybe<Scalars['ID']>;
  groupsIds?: Maybe<Array<Scalars['ID']>>;
  projectId?: Maybe<Scalars['ID']>;
};


export type QueryGetAnonymousSessionsArgs = {
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryGetAdaptiveInputArgs = {
  inputId: Scalars['ID'];
  sessionId: Scalars['ID'];
};


export type QueryGetAccountUsersExportUrlArgs = {
  filter?: Maybe<EducationMemberFilterInput>;
  variant?: Maybe<Scalars['String']>;
};


export type QueryGetAccountSessionsExportUrlArgs = {
  lang?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};


export type QueryGetChallengeTranscriptsExportUrlArgs = {
  challengeId?: Maybe<Scalars['ID']>;
  lang?: Maybe<Scalars['String']>;
  modifiedContent?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<Scalars['String']>;
};


export type QueryGetChallengesArgs = {
  filter?: Maybe<ChallengeFilterInput>;
  flatMode?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<ChallengeOrderBy>;
};


export type QueryGetProjectArgs = {
  challengeId?: Maybe<Scalars['ID']>;
  projectId?: Maybe<Scalars['ID']>;
};


export type QueryGetChallengeArgs = {
  challengeId: Scalars['ID'];
  externalUserId?: Maybe<Scalars['ID']>;
  path?: Maybe<Scalars['String']>;
};


export type QueryGetChallengeActionsArgs = {
  challengeId: Scalars['ID'];
};


export type QueryGetChallengeScenariosArgs = {
  challengeId: Scalars['ID'];
  path?: Maybe<Scalars['String']>;
};


export type QueryGetChallengeTriggerDictionariesArgs = {
  challengeId: Scalars['ID'];
};


export type QueryGetChallengeCutWordsDictionariesArgs = {
  challengeId: Scalars['ID'];
};


export type QueryGetChallengeHotWordsDictionariesArgs = {
  challengeId: Scalars['ID'];
};


export type QueryGetChallengeResultDescriptionsArgs = {
  challengeId: Scalars['ID'];
};


export type QueryGetChallengeParametricResultDescriptionsArgs = {
  challengeId: Scalars['ID'];
};


export type QueryGetNextChallengeArgs = {
  challengeId: Scalars['ID'];
  projectId?: Maybe<Scalars['ID']>;
};


export type QueryGetErrorsAudioArgs = {
  voice: Scalars['String'];
};


export type QueryGetUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetResetPasswordUserArgs = {
  hash: Scalars['String'];
};


export type QueryGetAccountByChallengeArgs = {
  challengeId: Scalars['ID'];
};


export type QueryGetExternalUserArgs = {
  challengeId: Scalars['ID'];
  externalUserId: Scalars['ID'];
};


export type QueryGetUsersByMixedDataArgs = {
  challengeIds?: Maybe<Array<Scalars['ID']>>;
  excludeGroupsIds?: Maybe<Array<Scalars['ID']>>;
  groupsIds?: Maybe<Array<Scalars['ID']>>;
  plainText?: Maybe<Scalars['String']>;
  usersIds?: Maybe<Array<Scalars['ID']>>;
};


export type QueryGetAssignmentErrorsDataArgs = {
  userId: Scalars['ID'];
};

export type ResetPasswordInformation = {
  __typename?: 'ResetPasswordInformation';
  email: Scalars['String'];
};

export type ResultDescription = {
  __typename?: 'ResultDescription';
  id: Scalars['ID'];
  minScore: Scalars['Int'];
  maxScore: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
};

export type ResultDescriptionInput = {
  minScore?: Maybe<Scalars['Int']>;
  maxScore?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum RpgInstructionParseStatus {
  NO_FILE = 'NO_FILE',
  READY = 'READY',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export type Scenario = {
  __typename?: 'Scenario';
  id: Scalars['ID'];
  name: Scalars['String'];
  isMain: Scalars['Boolean'];
  triggerPhrases: Array<Scalars['String']>;
  afterAction: ChallengeScenarioAfterAction;
  afterActionTarget: ChallengeScenarioAfterActionTarget;
  nextScenario?: Maybe<Scalars['ID']>;
  activationMethod: ChallengeScenarioActivationMethod;
  actions: Array<Action>;
  manualMaxScore?: Maybe<Scalars['Int']>;
};

export type ScenarioInput = {
  name?: Maybe<Scalars['String']>;
  triggerPhrases?: Maybe<Array<Scalars['String']>>;
  afterAction?: Maybe<ChallengeScenarioAfterAction>;
  afterActionTarget?: Maybe<ChallengeScenarioAfterActionTarget>;
  nextScenario?: Maybe<Scalars['ID']>;
  activationMethod?: Maybe<ChallengeScenarioActivationMethod>;
  manualMaxScore?: Maybe<Scalars['Int']>;
};

export type SessionResultFeedback = {
  __typename?: 'SessionResultFeedback';
  text: Scalars['String'];
  audioUrl?: Maybe<Scalars['String']>;
  feedbackStatus: FeedbackStatusEnumType;
};

export type SessionStartResult = {
  __typename?: 'SessionStartResult';
  sessionId: Scalars['ID'];
  recognitionEngine?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum SignUpStatus {
  SUCCESS = 'SUCCESS',
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  SHORT_PASSWORD = 'SHORT_PASSWORD',
  SHORT_USERNAME = 'SHORT_USERNAME',
  PASSWORDS_ARE_NOT_EQUAL = 'PASSWORDS_ARE_NOT_EQUAL',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

/** An enumeration. */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum SpeechSpeed {
  SLOW = 'SLOW',
  REASONABLE = 'REASONABLE',
  FAST = 'FAST'
}

export type StartRpgPracticeResult = {
  __typename?: 'StartRpgPracticeResult';
  isStarted: Scalars['Boolean'];
  avatarText?: Maybe<Scalars['String']>;
  avatarAudio?: Maybe<Scalars['String']>;
};

export type Student = User & {
  __typename?: 'Student';
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  extraEmail?: Maybe<Scalars['String']>;
  isStaff: Scalars['Boolean'];
  isDeveloper: Scalars['Boolean'];
  isExperimental: Scalars['Boolean'];
  experimentalMode: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  accountsCount: Scalars['Int'];
  groups: Array<Group>;
  top3Emotions: Array<EmotionStatType>;
  failReasons?: Maybe<Array<AssignmentFailReason>>;
  challenges?: Maybe<Array<ChallengeParticipationState>>;
};

export type SystemAction = Action & {
  __typename?: 'SystemAction';
  id: Scalars['ID'];
  audio?: Maybe<Scalars['String']>;
  isCustomAudio: Scalars['Boolean'];
  media?: Maybe<Scalars['String']>;
  mediaType?: Maybe<Scalars['String']>;
  mediaViewRequired?: Maybe<Scalars['Boolean']>;
  setMediaAsBackground?: Maybe<Scalars['Boolean']>;
  replaceCharacterWithMedia?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
};

export type SystemActionInput = {
  text?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Upload']>;
  mediaViewRequired?: Maybe<Scalars['Boolean']>;
  setMediaAsBackground?: Maybe<Scalars['Boolean']>;
  replaceCharacterWithMedia?: Maybe<Scalars['Boolean']>;
  customAudio?: Maybe<Scalars['Upload']>;
  regenerateAudio?: Maybe<Scalars['Boolean']>;
  beforeActionId?: Maybe<Scalars['ID']>;
};


export type Trainer = User & {
  __typename?: 'Trainer';
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  extraEmail?: Maybe<Scalars['String']>;
  isStaff: Scalars['Boolean'];
  isDeveloper: Scalars['Boolean'];
  isExperimental: Scalars['Boolean'];
  experimentalMode: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  accountsCount: Scalars['Int'];
  groups: Array<Group>;
  top3Emotions: Array<EmotionStatType>;
  failReasons?: Maybe<Array<AssignmentFailReason>>;
  challenges?: Maybe<Array<ChallengeParticipationState>>;
};

export type TriggerDictionaryInput = {
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<LanguageCode>;
  phrases?: Maybe<Scalars['String']>;
};

export type TriggerDictionaryType = {
  __typename?: 'TriggerDictionaryType';
  id: Scalars['ID'];
  name: Scalars['String'];
  languageCode: LanguageCode;
  phrases: Scalars['String'];
};

export type Utm = {
  source?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  campaign?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
};


export type User = {
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  extraEmail?: Maybe<Scalars['String']>;
  isStaff: Scalars['Boolean'];
  isDeveloper: Scalars['Boolean'];
  isExperimental: Scalars['Boolean'];
  experimentalMode: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  accountsCount: Scalars['Int'];
  groups: Array<Group>;
  top3Emotions: Array<EmotionStatType>;
  failReasons?: Maybe<Array<AssignmentFailReason>>;
  challenges?: Maybe<Array<ChallengeParticipationState>>;
};

/** An enumeration. */
export enum UserEmotion {
  NEUTRAL = 'NEUTRAL',
  JOY = 'JOY',
  ENTHUSIASM = 'ENTHUSIASM',
  ANGER = 'ANGER',
  GUILT = 'GUILT',
  SHAME = 'SHAME',
  FEAR = 'FEAR',
  DISGUST = 'DISGUST',
  SADNESS = 'SADNESS',
  SURPRISE = 'SURPRISE'
}

export type UserInputAction = Action & {
  __typename?: 'UserInputAction';
  id: Scalars['ID'];
  questionText: Scalars['String'];
  referenceText: Scalars['String'];
  hintText: Scalars['String'];
  analogTexts: Array<Scalars['String']>;
  freeSpeech?: Maybe<Scalars['Boolean']>;
  competence?: Maybe<Competence>;
};

export type UserInputActionInput = {
  questionText?: Maybe<Scalars['String']>;
  referenceText?: Maybe<Scalars['String']>;
  analogTexts?: Maybe<Array<Scalars['String']>>;
  hintText?: Maybe<Scalars['String']>;
  freeSpeech?: Maybe<Scalars['Boolean']>;
  competenceId?: Maybe<Scalars['String']>;
  beforeActionId?: Maybe<Scalars['ID']>;
};

/** An enumeration. */
export enum UserInputErrorReason {
  NO_ANSWER = 'NO_ANSWER',
  WRONG_ANSWER = 'WRONG_ANSWER',
  BAD_WORD = 'BAD_WORD',
  TIME_EXPIRED = 'TIME_EXPIRED',
  WRONG_CHOICE = 'WRONG_CHOICE',
  MISSING_KEYWORD = 'MISSING_KEYWORD',
  DAILO_SPEECH_TIMEOUT = 'DAILO_SPEECH_TIMEOUT',
  DAILO_SPEECH_HTTP_ERROR = 'DAILO_SPEECH_HTTP_ERROR',
  STOP_WORDS = 'STOP_WORDS',
  DAILO_STT_ERROR = 'DAILO_STT_ERROR',
  CHALLENGE_TIME_LIMIT_EXPIRED = 'CHALLENGE_TIME_LIMIT_EXPIRED',
  VIEWA_SERVICE_ERROR = 'VIEWA_SERVICE_ERROR'
}

export type UsersByMixedDataType = {
  __typename?: 'UsersByMixedDataType';
  users: Array<User>;
  emails?: Maybe<Array<Scalars['String']>>;
};
